import React, { useState } from 'react';
import { message } from 'antd';
import Input from '@lingxi-common-component/sirius-ui/Input';
import Button from '@lingxi-common-component/sirius-ui/Button';
import Modal from '@lingxi-common-component/sirius-ui/SiriusModal';
import { apiHolder, apis, getIn18Text, IApprovalRecordStatus } from 'api';
import styles from './index.module.scss';
const TEXT_CONFIG = {
    toApproval: {
        title: getIn18Text('TONGGUOSHENPI'),
        tip: getIn18Text('SEHNPIYITONGGUO'),
        placeHolder: getIn18Text('XUANTIAN') + ', ' + getIn18Text('QINGSHURU'),
        remarkInfo: getIn18Text('TONGGUOYUANYINBEIZHU'),
        actionStatus: IApprovalRecordStatus.approved,
    },
    toReject: {
        title: getIn18Text('BOHUISHENPI'),
        tip: getIn18Text('SHENPIYIBOHUI'),
        placeHolder: getIn18Text('QINGSHURU'),
        remarkInfo: getIn18Text('BOHUIYUANYIBEIZHU'),
        actionStatus: IApprovalRecordStatus.rejected,
    },
    toRecall: {
        title: getIn18Text('CHEHUISHENPI'),
        tip: getIn18Text('SHENPIYICHEHUI'),
        placeHolder: getIn18Text('QINGSHURU'),
        remarkInfo: getIn18Text('CHEHUIYUANYINBEIZHU'),
        actionStatus: IApprovalRecordStatus.recalled,
    },
};
const approvalFlowApi = apiHolder.api.requireLogicalApi(apis.approvalFlowApiImpl);
const ApprovalActionModal = ({ onClose, info }) => {
    const { actionType, visible } = info;
    const config = TEXT_CONFIG[actionType];
    const [remarks, setRemarks] = useState('');
    const [loading, setLoading] = useState(false);
    const formatBizName = info.bizName ? `${info.bizName.slice(0, 10)}${info.bizName.length > 10 ? '...' : ''}` : '';
    const resTip = `${getIn18Text('DINGDAN')}"${formatBizName}"${config.tip}`;
    const onCloseHandler = (closeType) => {
        onClose(closeType);
        setTimeout(() => {
            setRemarks('');
        }, 200);
    };
    const onConfirmHandler = async () => {
        setLoading(true);
        const params = {
            recordId: info.recordId,
            remarks,
            status: config.actionStatus,
        };
        const req = config.actionStatus === IApprovalRecordStatus.recalled
            ? approvalFlowApi.doRecallApproval.bind(approvalFlowApi)
            : approvalFlowApi.doModifyApprovalStatus.bind(approvalFlowApi);
        req(params)
            .then(success => {
            if (success) {
                message.open({ type: 'info', content: resTip, duration: 1 });
                onCloseHandler('success');
            }
        })
            .catch(e => {
            var _a;
            message.error(typeof e === 'string' ? e : ((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.message) || e.toString());
        })
            .finally(() => {
            setLoading(false);
        });
    };
    return (React.createElement(Modal, { title: config.title, visible: visible, footer: null, onCancel: () => onCloseHandler('cancel'), keyboard: false, maskClosable: false, getContainer: () => document.body },
        React.createElement("div", { className: styles.approvalModalContent },
            React.createElement("div", { className: styles.remarkTitle },
                actionType !== 'toApproval' ? React.createElement("span", { className: styles.required }, "*") : React.createElement(React.Fragment, null),
                React.createElement("div", { className: styles.remarkTitleContent }, config.remarkInfo)),
            React.createElement(Input.TextArea, { className: styles.input, placeholder: config.placeHolder, autoSize: { minRows: 3, maxRows: 5 }, value: remarks, showCount: true, onChange: e => setRemarks(e.target.value), style: { width: '100%', resize: 'none' }, maxLength: 100, allowClear: true }),
            React.createElement("div", { className: styles.footer },
                React.createElement(Button, { btnType: "minorLine", onClick: () => onCloseHandler('cancel') }, getIn18Text('QUXIAO')),
                React.createElement(Button, { btnType: "primary", disabled: actionType !== 'toApproval' && !remarks, loading: loading, onClick: onConfirmHandler }, getIn18Text('QUEREN'))))));
};
export default ApprovalActionModal;
